export const ENVIRONMENT = import.meta.env.ENVIRONMENT;
export const APP_API_URL = import.meta.env.APP_API_URL;
